/**
 * Data proses maintenance (structured content).
 */
export const processSteps = [
  {
    number: "01",
    title: "Konsultasi",
    description:
      "Diskusi awal untuk memahami kebutuhan maintenance AC & HVAC Anda.",
  },
  {
    number: "02",
    title: "Survey Lokasi",
    description:
      "Kunjungan ke lokasi untuk meninjau kondisi unit dan fasilitas.",
  },
  {
    number: "03",
    title: "Assessment",
    description:
      "Pemeriksaan kondisi unit dan penilaian kebutuhan maintenance.",
  },
  {
    number: "04",
    title: "Penawaran",
    description:
      "Penyusunan penawaran layanan yang sesuai dengan kebutuhan.",
  },
  {
    number: "05",
    title: "Maintenance",
    description:
      "Pelaksanaan pekerjaan maintenance sesuai kesepakatan.",
  },
  {
    number: "06",
    title: "Monitoring",
    description:
      "Pemantauan berkelanjutan untuk menjaga performa sistem.",
  },
];

export default processSteps;
